export const DEFAULT_EXPLORE_PROGRAM_SHORT_NAME = "B.ENG. AiCE";

export function getProgramShortNameForSemesterApi(program: any): string {
  if (!program) return "";
  if (
    program.label === "ALL" ||
    program.label === "ALL Programs" ||
    program.value === "ALL" ||
    program.program_abbrev === "ALL"
  ) {
    return "";
  }
  return program.short_name || "";
}

export function getDefaultExploreProgram(programs: any[]): any | undefined {
  if (!programs?.length) return undefined;
  return (
    programs.find(
      (p) =>
        p.short_name === DEFAULT_EXPLORE_PROGRAM_SHORT_NAME ||
        p.label === DEFAULT_EXPLORE_PROGRAM_SHORT_NAME ||
        p.value === DEFAULT_EXPLORE_PROGRAM_SHORT_NAME ||
        p.program_name === DEFAULT_EXPLORE_PROGRAM_SHORT_NAME
    ) || programs[0]
  );
}
